import { Modal, Button, Input } from 'semantic-ui-react';
import { formatMoneyWithCurrency } from 'src/utils/formatter';

const CustomModal = ({
  open,
  onClose,
  title,
  content,
  onConfirm,
  confirmLabel,
  confirmDisabled,
  isLoading = false,
  size = 'tiny',
  cancelarLabel = 'Cancelar',
  classNameTitle,
  footer,
  footerTwo,
  classNameContent
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      size={size}
      dimmer={{ style: { zIndex: 9999, backgroundColor: 'rgba(0,0,0,.6)', backdropFilter: 'blur(3px)' } }}
      style={{maxWidth:'80%'}}
    >
      <Modal.Header
        className={classNameTitle}
      >
        {title}
      </Modal.Header>
      <Modal.Content className={classNameContent}>
        {content}
      </Modal.Content>
      <Modal.Actions>
        <div className='tw-flex tw-justify-between tw-items-center'>
          <div className=''>
            {footer &&
              <div>
                <p className='tw-text-base tw-text-[#3C4B64] tw-font-semibold'>{footer}: {formatMoneyWithCurrency(footerTwo)}</p>
              </div>
            }
          </div>
          <div>
            <Button onClick={onClose}>{cancelarLabel}</Button>
            {confirmLabel &&
              <Button color="blue" onClick={onConfirm} disabled={confirmDisabled} loading={isLoading}>
                {confirmLabel}
              </Button>
            }
          </div>
        </div>
      </Modal.Actions>
    </Modal>
  );
};

export default CustomModal;
